<div class="signupContent">
    <form class="login100-form validate-form">
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="customer.email" name="email" placeholder="Email">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="password" [(ngModel)]="customer.password" spellcheck=false name="pass"
                placeholder="Mot de passe">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="container-login100-form-btn">
            <button class="login100-form-btn" (click)="login()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                Connexion
            </button>
        </div>
        <div class="footer">
            <table width="100%">
                <tr>
                    <td>
                        <a class="txt2 cursor-pointer" routerLink="../recuperation/mdp">
                            Mot de passe oublié ?
                        </a>
                    </td>
                    <td class="a1">
                        <button routerLink="../inscription" class="login-btn">
                            S'inscrire &nbsp;&nbsp;
                            <i class="glyphicon glyphicon-arrow-right"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    </form>
</div>